import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { Replay } from '@sentry/replay';
// name is optional
Vue.config.productionTip = false;
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    ignoreErrors: [
      /Non-Error exception captured/,
      /Non-Error promise rejection captured/,
    ],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      ...(process.env.VUE_APP_ADDING_SENTRY_SESSION_REPLAY === 'true' ? [new Replay()] : []),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
Vue.component('AvatarImage', () => import('@/components/avatarImage/index.vue'));
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
